import type { ComponentProps } from 'react'

/** Generated from Penpot `icons / chevron left`; mirror it for `chevron right`. Do not edit by hand. */
export function ChevronIcon(props: ComponentProps<'svg'>) {
  return (
    <svg viewBox="0 0 8 14" fill="currentColor" aria-hidden="true" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M8,12.37L6.49,14L0,7L6.49,0L8,1.63L3.03,7L8,12.37Z" />
    </svg>
  )
}
